// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Share: React.FC = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="14" height="13" viewBox="0 0 14 13">
            <path fill="currentColor" d="M9.75,7.5 L9,7.5 L9,5.25 L8.625,5.25 L8.21484375,5.25 C6.99140596,5.25 6,6.24140596 6,7.46484375 C6,8.38593721 6.75,9 6.75,9 C6.75,9 3.75,8.07890654 3.75,5.625 C3.75,3.76171875 5.26171875,2.25 7.125,2.25 L9,2.25 L9,0 L9.75,0 L13.5,3.75 L9.75,7.5 Z M0,1.5 L0.75,1.5 L2.25,1.5 L3,1.5 L3,3 L2.25,3 L1.5,3 L1.5,10.5 L9,10.5 L9,9.75 L9,9 L10.5,9 L10.5,9.75 L10.5,11.25 L10.5,12 L9.75,12 L0.75,12 L0,12 L0,11.25 L0,2.25 L0,1.5 Z" transform="translate(0 .5)"/>
        </svg>
    );
};

export default React.memo(Share);
